import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import {currencyFormat} from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt,faArrowRight } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: []
    }
  

    ListarArrayResultado(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("materiales/index/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', arrayResultado: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
                Swal.close();
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    PasarMp(id) {
        Swal.showLoading();
        let cantidad = document.getElementById('cantidadProducto_'+id).value;
        var usuario = window.localStorage.getItem('idusuario');
        console.log(cantidad+' '+id+' '+this.props.apu+' '+usuario);
         var datosEnviar = {
            tipo_mp: 'MAT',
            codigo_mp: id,
            apu: this.props.apu,
            cantidad: cantidad,
            rendimiento: 1,
            usuario:usuario
        }
        Swal.showLoading();
        authAxios.post("productos/registrar_material", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Materiales!',
                        datosRespuesta.data.msj,
                        'success'
                    );
                   
                } else {
                    Swal.close();
                    Swal.fire(
                        'Materiales!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log) 

        
    }
    componentDidMount() {
        this.ListarArrayResultado(1);
    }
    render() {
        const { load, arrayResultado, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        
                        <div className="card-body">
                            
                            <div className="row">
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="Material" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                        <th className="align-middle">COD</th>
                                        <th className="align-middle">TIPO</th>
                                            <th className="align-middle">COD. SIESA</th>
                                            <th className="align-middle">MATERIAL</th>
                                            <th className="align-middle">UNIDAD</th>
                                            <th className="align-middle">VALOR COMPRA</th>
                                            <th className="align-middle">VALOR UNITARIO</th>
                                            
                                            <th className="align-middle">CANT</th>
            
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            arrayResultado.map((itemArrayResultado) => (
                                                <tr key={itemArrayResultado.ID_TABLA}>
                                                    <td>{itemArrayResultado.CODIGO}</td>
                                                    <td>{itemArrayResultado.TIPO}</td>
                                                    <td>{itemArrayResultado.COD_SIESA}</td>
                                                    <td>{itemArrayResultado.NOMBRE}</td>
                                                    {
                                                        (() => {
                                                            switch (itemArrayResultado.ID_TIPO_UNIDAD) {
                                                                case 1:
                                                                    return (<td>GLB</td>)
                                                                case 2:
                                                                    return (<td>M</td>)
                                                                case 3:
                                                                    return (<td>ROLLO</td>)
                                                                case 4:
                                                                    return (<td>UND</td>)
                                                            }
                                                        })()
                                                    }
                                                     <td><b>$ </b>{currencyFormat(itemArrayResultado.VALOR_COMPRA)}</td>
                                                    <td><b>$ </b>{currencyFormat(itemArrayResultado.VALOR_UNITARIO)}</td>
                                                   
                                                    <td>
                                                    <input className={"form-control form-control-sm"}
                                                                        type="text" id={'cantidadProducto_' + itemArrayResultado.ID_TABLA}
                                                                        name={'cantidadProducto_' + itemArrayResultado.ID_TABLA}
                                                                        aria-describedby="helpId" />
                                                    </td>
                                             
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() =>
                                                                    this.PasarMp(itemArrayResultado.ID_TABLA)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faArrowRight} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;